"use client";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import FinancialBarChart from "@/components/FinancialBarChart";

const FinancialTable = ({ tableHeaders, companyData }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedHeader, setSelectedHeader] = useState("");

  useEffect(() => {
    console.log("Table Component Mounted");

    const handleClick = (event) => {
      const clickedElement = event.target;
      const clickedRow = clickedElement.closest("tr");
      const clickedTable = clickedElement.closest("table");

      if (clickedTable && clickedRow) {
        const firstCellText = clickedRow
          .querySelector("td:first-child")
          ?.textContent.trim();
        console.log("First cell text:", firstCellText);

        // companyData içindeki her bir itemDescTr değerini kontrol ediyoruz
        const matchedItem = Object.values(companyData).find(
          (item) =>
            item.itemDescTr.trim().toLowerCase() === firstCellText.toLowerCase()
        );

        if (matchedItem) {
          console.log("This is the target row with Kalem:", firstCellText);
          setSelectedHeader(firstCellText);
          displayFinancialData(firstCellText);
        } else {
          console.log("This is not the target row.");
        }
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [tableHeaders, companyData]);

  const displayFinancialData = (header) => {
    const dataEntry = companyData.find((item) => item.itemDescTr === header);
    if (dataEntry) {
      console.log("Data Entry found:");
      const data = Object.keys(dataEntry)
        .filter(
          (key) =>
            key !== "itemDescTr" &&
            key !== "itemDescEng" &&
            dataEntry[key] !== ""
        )
        .map((key) => ({
          label: key,
          value: parseFloat(dataEntry[key]),
        }));

      setSelectedData(data.reverse());
      setModalIsOpen(true); // Modalı aç
    } else {
      console.log("No Data Entry found for:", header);
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <>
      {/* Modal Component */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Financial Data Modal"
        ariaHideApp={false}
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#1e1e1e",
            color: "#ffffff",
            padding: "10px",
            borderRadius: "10px",
            border: "none",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
          },
        }}
      >
        {selectedData && (
          <FinancialBarChart
            data={selectedData.map((d) => d.value)}
            labels={selectedData.map((d) => d.label)}
            title={selectedHeader}
          />
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <button
            onClick={closeModal}
            style={{
              backgroundColor: "#d9534f",
              color: "#fff",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
            }}
          >
            Kapat
          </button>
        </div>
      </Modal>
    </>
  );
};

export default FinancialTable;
